import React from 'react';

import type { BaseEntry } from '../../../content/types/entry';
import { SplitFeature, type SplitFeaturePlacement } from './SplitFeature';

type EntryFeatureProps = {
  entry: BaseEntry;
  placement: SplitFeaturePlacement;
  detailPath: string;
};

export const EntryFeature: React.FC<EntryFeatureProps> = ({ entry, placement, detailPath }) => {
  return (
    <SplitFeature
      title={entry.title}
      image={entry.image}
      tags={entry.tags}
      date={entry.date}
      description={entry.longDescription ?? entry.description}
      detailPath={detailPath}
      placement={placement}
    />
  );
};
